export const WEB_STORAGE_CONFIG = {
  namespace: 'uicl-boilerplate',
};
